export default __webpack_public_path__ + "static/media/13-INT-(4-3).98f030dd.jpg";